import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
export var ScriptTypes;
(function (ScriptTypes) {
    ScriptTypes["LD_JSON"] = "application/ld+json";
})(ScriptTypes || (ScriptTypes = {}));
const _HtmlInclude = ({ htmlFragment, scriptFragment, styleFragment, className, scriptType, id, }) => {
    if (htmlFragment) {
        return _jsx("div", { id: id, className: className, dangerouslySetInnerHTML: { __html: htmlFragment } });
    }
    else if (scriptFragment) {
        return _jsx("script", { id: id, dangerouslySetInnerHTML: { __html: scriptFragment }, type: scriptType });
    }
    else if (styleFragment) {
        return _jsx("style", { id: id, className: className, dangerouslySetInnerHTML: { __html: styleFragment } });
    }
    return null;
};
const HtmlInclude = memo(_HtmlInclude);
export { HtmlInclude };
